import { useNavigate } from 'react-router-dom';
import { BotonRegresarProps } from '../../interfaces/globalInterfaces';
import './BotonRegresar.scss';

export const BotonRegresar = ({ backHandler }: BotonRegresarProps) => {
  const navigate = useNavigate();

  const validarRegresar = async () => {
    if (window.history.length > 2) {
      backHandler ? backHandler() : navigate(-1)
    }
    else {
      navigate('/', { replace: true });
    }

  };

  return (
    <>
      <div
        className="boton-regresar link"
        onClick={() => (
          validarRegresar()
        )
        }
      >
        <div className="material-icons-outlined">chevron_left</div> Regresar
      </div>
    </>
  );
};
